import React from "react";
import { Form, Row, Space } from "@masterteam/mt-design-react";
import { useIntl } from "react-intl";
import Collapse from "../Collapse";

import { ReactComponent as RequestDetailsIcon } from "../../assets/images/request-details.svg";

import "./style.scss";

const { Field } = Form;

const RequestDetails = ({ kpiDetails, isReadOnly }) => {
  const intl = useIntl();
  const isAr = intl.locale === "ar";

  return (
    <Collapse
      defaultExpanded
      title={intl.formatMessage({
        id: "change-request.request-details",
      })}
      icon={<RequestDetailsIcon />}
    >
      <Space direction="vertical" size="large" className="body">
        <Row>
          <Field
            label={intl.formatMessage({ id: "kpi-name" })}
            inputProps={{
              placeholder: intl.formatMessage({
                id: "kpi-name",
              }),
              value: isAr ? kpiDetails?.ArabicName : kpiDetails?.EnglishName,
            }}
            hideErrorMessage
            disabled
          />
        </Row>
        <Row size="large">
          <Field
            type="date"
            name="Created"
            disabled={true}
            label={intl.formatMessage({
              id: "change-request.request-date",
            })}
            hideErrorMessage
          />
          <Field
            name="CreatedBy"
            label={intl.formatMessage({
              id: "change-request.requester",
            })}
            inputProps={{
              placeholder: intl.formatMessage({
                id: "change-request.requester",
              }),
            }}
            disabled={true}
            hideErrorMessage
          />
        </Row>

        <Row size="large">
          <Field
            type="textarea"
            name="RequestDescription"
            label={intl.formatMessage({
              id: "change-request.request-description",
            })}
            inputProps={{
              placeholder: intl.formatMessage({
                id: "change-request.request-description",
              }),
            }}
            disabled={isReadOnly}
            hideErrorMessage
            required
          />
        </Row>
      </Space>
    </Collapse>
  );
};

export default RequestDetails;
